import { FC } from 'react';
import styles from './interactiveAlertDialog.module.scss';
import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import DialogBox from 'components/Dialoges/DialogBox';
import Button from 'components/FormControl/Button';
import { Props } from './types';

const InteractiveAlertDialog: FC<Props> = ({ open, title, Body, actions, onClose }) => (
  <DialogBox open={open} onClose={onClose}>
    <DialogContent className={styles.container}>
      <DialogTitle className={styles.title}>{title}</DialogTitle>
      <Body />
      {actions && (
        <DialogActions className={styles.actionsContainer}>
          {actions?.map((action) => (
            <Button
              key={action.label}
              text={action.label}
              variant={action.variant || 'contained'}
              color={action.color}
              size={action.size || 'small'}
              onClick={() => action.handler()}
              enableLoading={true}
            />
          ))}
        </DialogActions>
      )}
    </DialogContent>
  </DialogBox>
);

export default InteractiveAlertDialog;
